import React, { FunctionComponent, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { trackLoad, trackPage } from '../../utils/tracking';

const Tracking: FunctionComponent = ({ children }) => {
  const { location } = useHistory();

  useEffect(() => {
    trackLoad();
  }, []);

  useEffect(() => {
    trackPage();
  }, [location.pathname]);

  return <>{children}</>;
};

export default Tracking;
